@if (this.status === 0) {
  <app-address-lookup
    [(postcode)] = "tad_postcode_store"
    [(hasSearched)] = "tad_has_search_store"
    [(hasAddressSelected)] = "tad_hasAddress_selected_store"
    (lookup_form_out)="handleLookupForm($event)"
  [index] = "index"></app-address-lookup>
}
@if (this.status === 1) {
  <app-address-editor
    [index] = "index"
    [incomingAddress]="incomingAddress"
    (addressIsValid)="addressUpdate($event)"
  (form_out)="_handleIncomingForm($event)"></app-address-editor>
}
@if (this.status === 2) {
  <app-address-display [index] = "index"></app-address-display>
}